declare function require(moduleName: string): any;
const { version: appVersion } = require('../../../package.json')
import {Component, OnInit} from '@angular/core';
import {ModelService} from "../services/model.service";
import {SofiService} from "../services/sofi.service";
import {Router} from "@angular/router";
import {DomSanitizer} from "@angular/platform-browser";
import {StorageService} from "../services/storage.service";

@Component({
    selector: 'app-offer',
    templateUrl: './offer.component.html',
    styleUrls: ['./offer.component.scss']
})
export class OfferComponent implements OnInit {
    triedSubmit: boolean = false;
    labelName: string = 'Name';
    isCustomerkindJuristic = false;
    version: string;


    constructor(protected modelService: ModelService,
                private sofiService: SofiService,
                private storageService: StorageService,
                private router: Router,
                private sanitizer: DomSanitizer) {
        this.version = appVersion;
    }

    ngOnInit() {
        let salesman = this.storageService.getSalesman();
        if (salesman) {
            this.modelService.salesman = salesman;
        }
        let user = this.storageService.getUser();
        if (user) {
            this.modelService.user = user;
        }
        this.modelService.customer.customerkind = this.modelService.customer.customerkind || '1';
        this.updateCustomerKindSettings();
    }

    onTouch() {
        this.triedSubmit = true;
    }

    onSubmit() {

        let sofi = {
            salesman: this.modelService.salesman,
            customer: this.modelService.customer
        };

        if (sofi.customer.customerkind === '3') {
            sofi.customer.title = '3';
        }


        this.sofiService.sendToElvis(sofi)
            .subscribe((data) => {

                console.log('Elvis Url', data);

                this.storageService.saveSalesman(sofi.salesman);

                this.modelService.elvisUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
                this.router.navigate(['/elvis'])
            });
    }

    onCustomerkindChange() {
        this.updateCustomerKindSettings();
    }

    private updateCustomerKindSettings() {
        if (this.modelService.customer.customerkind === '3') {
            this.labelName = 'Firmenname';
            this.isCustomerkindJuristic = true;
        } else {
            this.labelName = 'Name';
            this.isCustomerkindJuristic = false;
        }
    }

    birthdateChanged($event: any) {
        this.modelService.customer.birthdate = this.numbersToDateString($event);
    }

    /**
     * convert string containing numbers to date string
     * DDMMYYYY -> DD.MM.YYYY
     * @param numbers
     * @private
     */
    private numbersToDateString(numbers: string) {
        if (!numbers) {
            return numbers;
        }
        if (/^\d{8}$/.test(numbers)) {
            return numbers.substr(0,2) + '.' +
                numbers.substr(2,2) + '.' +
                numbers.substr(4,4);
        }
        return numbers;
    }
}
